<!--<div class="app-page-container">

</div>-->
<!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
@if (!isIframe) {
  <router-outlet></router-outlet>
}
